import { Component, computed, effect, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardComponent } from '../../../../common/card/card.component';
import { Api } from '../../../../api/api';
import { getLatestEnergyReading } from '../../../../api/functions';
import { LocationStateService } from '../../../../common/services/location-state.service';
import { rxResource, toSignal } from '@angular/core/rxjs-interop';
import { from, interval } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-energy-status',
  imports: [CommonModule, CardComponent, RouterLink],
  templateUrl: './energy-status.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './energy-status.component.css',
})
export class EnergyStatusComponent {
  protected readonly Math = Math;
  api = inject(Api);
  locationStateService = inject(LocationStateService);

  params = computed(() => ({
    location_id: this.locationStateService.currentLocation()?.id ?? ''
  }));

  private readonly SAMPLE = {
    "productionStatus": {
      "total": 0.377211,
      "values": [
        {
          "id": "0518d382-c229-4b95-a6b6-34390d8f2767",
          "name": "2Kanter_S0",
          "value": 0.142031
        },
        {
          "id": "6667f0e5-aabc-4e0b-8d63-c7cf72ea58ac",
          "name": "2Kanter_S1",
          "value": 0.23518
        }
      ]
    },
    "batteryChargeStatus": {
      "total": 0.089,
      "values": [
        {
          "id": "8db8d3dd-9775-4809-a449-fac24d30513c",
          "name": "2Kanter_B",
          "value": 89
        }
      ]
    },
    "batteryPowerStatus": {
      "total": -6.852061,
      "values": [
        {
          "id": "8db8d3dd-9775-4809-a449-fac24d30513c",
          "name": "2Kanter_B",
          "value": -6.852061
        }
      ]
    },
    "calculatedBatteryPowerStatus": {
      "total": -1370.41,
      "values": [
        {
          "id": "8db8d3dd-9775-4809-a449-fac24d30513c",
          "name": "2Kanter_B",
          "value": -1370.41
        }
      ]
    },
    "consumptionStatus": {
      "total": 7.130906,
      "values": [
        {
          "id": "0a34e6b9-c94a-4e8c-8461-9c9468cf5c79",
          "name": "HeatPump",
          "value": 0.062803
        },
        {
          "id": "4581f36f-9661-470f-b1ba-c358992a4712",
          "name": "Allgemein",
          "value": 7.067945
        },
        {
          "id": "fa0699c9-fd44-4c39-b2db-436bcf56ad0e",
          "name": "Wallbox 2Kanter",
          "value": 0.000158
        }
      ]
    },
    "networkStatus": {
      "values": [
        {
          "id": "eab60923-af56-44fb-9d9a-b94294f40e5f",
          "name": "2Kanter_Meter",
          "value": -0.085554
        }
      ]
    }
  };
  resource = rxResource({
    params: this.params,
    defaultValue: environment.showDefault ? this.SAMPLE : undefined,
    stream: (loaderParams) => from(this.api.invoke(getLatestEnergyReading, loaderParams.params)),
  });

  /** Latest reading, or undefined while loading or after a failed request (value() throws in the error state). */
  status = computed(() => (this.resource.hasValue() ? this.resource.value() : undefined));

  poll = toSignal(interval(5000));

  constructor() {
    effect(() => {
      this.poll();
      this.resource.reload();
    });
  }
}
